import React from 'react';
import { Link } from 'react-router-dom';
import { Section } from '../components/ui';
import mslogo from '../assets/images/MSMlogo_white.png';
import './Footer.css';

const Footer = () => {
    return (
        <Section variant="small" className="footer-section">
            <footer className="footer-container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <Link to="/" className="footer-logo-link">
                            <img src={mslogo} alt="MotionSpace" className="footer-logo" />
                        </Link>
                        <p className="footer-subtitle">
                            Change consulting, capital, and technology—for lasting transformation
                        </p>
                    </div>

                    <nav className="footer-nav" aria-label="Footer">
                        <div className="footer-nav-col">
                            <div className="footer-nav-heading">Explore</div>
                            <Link to="/" className="footer-nav-link">
                                Home
                            </Link>
                            <Link to="/about" className="footer-nav-link">
                                About
                            </Link>
                            <Link to="/services" className="footer-nav-link">
                                Services
                            </Link>
                            <Link to="/contact" className="footer-nav-link">
                                Contact
                            </Link>
                        </div>
                        <div className="footer-nav-col">
                            <div className="footer-nav-heading">Home sections</div>
                            <a href="/#business-lines" className="footer-nav-link">
                                Business lines
                            </a>
                            <a href="/#approach" className="footer-nav-link">
                                Approach
                            </a>
                            <a href="/#capabilities" className="footer-nav-link">
                                Opportunities
                            </a>
                        </div>
                        <div className="footer-nav-col">
                            <div className="footer-nav-heading">Legal</div>
                            <Link to="/privacy-policy" className="footer-nav-link">
                                Privacy Policy
                            </Link>
                            <Link to="/media" className="footer-nav-link">
                                Media &amp; credits
                            </Link>
                        </div>
                    </nav>
                </div>

                <div className="footer-bottom">
                    <div className="footer-copyright">
                        <span className="footer-copyright-text">
                            Copyright © 2026 MotionSpace. All rights reserved.
                        </span>
                    </div>
                </div>
            </footer>
        </Section>
    );
};

export default Footer;
